import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import 'react';
import { jsx } from '@emotion/core/jsx-runtime';
import { SSRProvider } from '@react-aria/ssr';

var index = (function (props) {
  return jsx(SSRProvider, _extends({}, props));
});

export default index;
//# sourceMappingURL=index.esm.js.map
